import React from 'react';
import styles from './Guarantees.module.scss';
import PaymentOptions from './components/paymentOptions';

import GuaranteePoints from './components/guaranteePoints';
import HowItWorksPoints from './components/howItWorksPoints';

interface IGuaranteesProps {
  aboveComponents?: any;
  guranteePoints?: any;
  paymentOptions?: any;
  howItWorksPoints?: any;
}

const Guarantees = (props: IGuaranteesProps) => (
  <div className={styles.guarantees}>
    {props.aboveComponents}
    {props.guranteePoints}
    {props.paymentOptions}
    {props.howItWorksPoints}
  </div>
);

Guarantees.defaultProps = {
  guranteePoints: <GuaranteePoints/>,
  paymentOptions: <PaymentOptions/>,
  points: <HowItWorksPoints/>
};

export default React.memo(Guarantees);
